interface AppCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/** Checkbox nhỏ, nhất quán cho các danh sách lựa chọn trong ERP. */
export function AppCheckbox({ checked, onChange, disabled = false, ariaLabel }: AppCheckboxProps) {
  return (
    <span className="app-checkbox">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span aria-hidden="true">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
      </span>
    </span>
  );
}
